import { useState } from 'react';
import { contabilidadService } from '../../services/api';
import '../../styles/Clientes.css';

const CalculadoraCuota = () => {
  const [modalidad, setModalidad] = useState('');
  const [tipoPrestamo, setTipoPrestamo] = useState('');
  const [capital, setCapital] = useState('');
  const [tasaMensual, setTasaMensual] = useState('');
  const [cuotas, setCuotas] = useState('');
  const [cuota, setCuota] = useState('');
  const [resultado, setResultado] = useState(null);
  const [loading, setLoading] = useState(false);

  const formatMoney = (amount) => {
    return `$${(amount || 0).toLocaleString('es-DO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };

  const handleLimpiar = () => {
    setModalidad('');
    setTipoPrestamo('');
    setCapital('');
    setTasaMensual('');
    setCuotas('');
    setCuota('');
    setResultado(null);
  };

  const handleCalcular = async () => {
    if (!capital || !tasaMensual || !cuotas || !modalidad || !tipoPrestamo) {
      alert('Por favor complete todos los campos');
      return;
    }

    setLoading(true);
    try {
      const data = {
        capital: parseFloat(capital),
        tasa_mensual: parseFloat(tasaMensual),
        cuotas: parseInt(cuotas),
        tipo_prestamo: tipoPrestamo,
        modalidad: modalidad
      };

      const response = await contabilidadService.calcularCuota(data);
      const resultadoData = response.data;

      setCuota(resultadoData.cuota.toFixed(2));
      setResultado(resultadoData);
    } catch (error) {
      console.error('Error al calcular:', error);
      alert('Error al calcular la cuota: ' + (error.response?.data?.error || error.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>🧮 Calculadora de Cuota</h1>
        <p>Calcule cuotas y genere tabla de amortización</p>
      </div>

      <div className="card">
        <div className="card-header">
          <h2>Datos del préstamo</h2>
        </div>
        <div className="card-body">
          <div className="form-grid" style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}>
            <div className="form-group">
              <label>Modalidad</label>
              <select
                value={modalidad}
                onChange={(e) => setModalidad(e.target.value)}
                className="form-control"
              >
                <option value="">-- Seleccione --</option>
                <option value="diario">Diario</option>
                <option value="semanal">Semanal</option>
                <option value="quincenal">Quincenal</option>
                <option value="mensual">Mensual</option>
              </select>
            </div>

            <div className="form-group">
              <label>Tipo de préstamo</label>
              <select
                value={tipoPrestamo}
                onChange={(e) => setTipoPrestamo(e.target.value)}
                className="form-control"
              >
                <option value="">-- Seleccione --</option>
                <option value="simple">Interés Simple</option>
                <option value="compuesto">Interés Compuesto</option>
              </select>
            </div>

            <div className="form-group">
              <label>Capital</label>
              <input
                type="number"
                value={capital}
                onChange={(e) => setCapital(e.target.value)}
                className="form-control"
                placeholder="0.00"
                step="0.01"
              />
            </div>

            <div className="form-group">
              <label>Tasa Mensual (%)</label>
              <input
                type="number"
                value={tasaMensual}
                onChange={(e) => setTasaMensual(e.target.value)}
                className="form-control"
                placeholder="0.00"
                step="0.01"
              />
            </div>

            <div className="form-group">
              <label>Cuotas</label>
              <input
                type="number"
                value={cuotas}
                onChange={(e) => setCuotas(e.target.value)}
                className="form-control"
                placeholder="0"
              />
            </div>

            <div className="form-group">
              <label>Cuota</label>
              <input
                type="text"
                value={cuota}
                readOnly
                className="form-control"
                style={{ background: '#f8f9fa', fontWeight: 'bold' }}
                placeholder="0.00"
              />
            </div>
          </div>

          <div style={{
            display: 'flex',
            gap: '1rem',
            justifyContent: 'flex-end',
            marginTop: '1rem'
          }}>
            <button onClick={handleLimpiar} className="btn btn-secondary">
              Limpiar
            </button>
            <button
              onClick={handleCalcular}
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'Calculando...' : 'Calcular'}
            </button>
          </div>
        </div>
      </div>

      {resultado && (
        <>
          {/* Resumen del Préstamo */}
          <div className="card">
            <div className="card-header">
              <h2>Resumen del Préstamo</h2>
            </div>
            <div className="card-body">
              <div className="stats-grid" style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gap: '1rem'
              }}>
                <div style={{
                  padding: '1.5rem',
                  background: '#f8f9fa',
                  borderRadius: '8px',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: '0.875rem', color: '#666', marginBottom: '0.5rem' }}>
                    Capital
                  </div>
                  <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#2196F3' }}>
                    {formatMoney(resultado.capital)}
                  </div>
                </div>

                <div style={{
                  padding: '1.5rem',
                  background: '#f8f9fa',
                  borderRadius: '8px',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: '0.875rem', color: '#666', marginBottom: '0.5rem' }}>
                    Intereses
                  </div>
                  <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#FF9800' }}>
                    {formatMoney(resultado.intereses)}
                  </div>
                </div>

                <div style={{
                  padding: '1.5rem',
                  background: '#f8f9fa',
                  borderRadius: '8px',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: '0.875rem', color: '#666', marginBottom: '0.5rem' }}>
                    Cuota
                  </div>
                  <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#4CAF50' }}>
                    {formatMoney(resultado.cuota)}
                  </div>
                </div>

                <div style={{
                  padding: '1.5rem',
                  background: '#2196F3',
                  borderRadius: '8px',
                  textAlign: 'center',
                  color: 'white'
                }}>
                  <div style={{ fontSize: '0.875rem', marginBottom: '0.5rem' }}>
                    Total a Pagar
                  </div>
                  <div style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
                    {formatMoney(resultado.total)}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Tabla de Amortización */}
          <div className="card">
            <div className="card-header">
              <h2>Tabla de Amortización</h2>
              <button className="btn btn-success">
                📄 Imprimir Tabla
              </button>
            </div>
            <div className="table-container">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Capital</th>
                    <th>Interés</th>
                    <th>Cuota</th>
                    <th>Saldo</th>
                  </tr>
                </thead>
                <tbody>
                  {resultado.tabla.map((pago) => (
                    <tr key={pago.cuota}>
                      <td>{pago.cuota}</td>
                      <td>{formatMoney(pago.capital)}</td>
                      <td>{formatMoney(pago.interes)}</td>
                      <td><strong>{formatMoney(pago.cuota_total)}</strong></td>
                      <td>{formatMoney(pago.saldo)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr style={{ background: '#f8f9fa', fontWeight: 'bold' }}>
                    <td>TOTAL</td>
                    <td>{formatMoney(resultado.capital)}</td>
                    <td>{formatMoney(resultado.intereses)}</td>
                    <td>{formatMoney(resultado.total)}</td>
                    <td>$0.00</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </>
      )}

      {!resultado && (
        <div style={{
          padding: '3rem',
          textAlign: 'center',
          color: '#666',
          background: '#f8f9fa',
          borderRadius: '8px',
          margin: '2rem 0'
        }}>
          <p style={{ fontSize: '1.125rem', margin: 0 }}>
            📊 Complete los datos del préstamo y haga clic en "Calcular" para ver la tabla de amortización
          </p>
        </div>
      )}
    </div>
  );
};

export default CalculadoraCuota;
